


import { initializeApp } from 'firebase/app';
import { getMessaging, onMessage } from 'firebase/messaging';

// import { SERVER } from '../constants';
// import { HttpClient } from '../utils/requests';

const firebaseConfig = {
  apiKey: "AIzaSyAcm8NmXpsbz7Cx9lo3UCBsFp9ghG1xmqM",
  authDomain: "mozaffari-gaz.firebaseapp.com",
  projectId: "mozaffari-gaz",
  storageBucket: "mozaffari-gaz.appspot.com",
  messagingSenderId: "965823925175",
  appId: "1:965823925175:web:9f766a5afaca36df077632",
  measurementId: "G-STQYQBGJ2Y"
};

initializeApp(firebaseConfig);
const messaging = getMessaging();

export const requestForToken = () => {
  // const notify = useNotify(); // Initialize notify object to send notification to dashboard

  // if (!localStorage.getItem("fcm_token"))
  // return getToken(messaging, { vapidKey: "BHQRQZSkiyL16iL2HshmJHhXafI_69VcHYfV8Bro6YMy6OmMZt5OD3cVPyOyF8uLaA04CetrRbta8VZthued_F4" })
  //   .then((currentToken) => {

  //     if (currentToken) {
  //       console.log('current token for client: ', currentToken);
  //       localStorage.setItem("fcm_token", currentToken)
  //       // Perform any other neccessary action with the token
  //       // const token = localStorage.getItem(AUTH_TYPES.AUTHORIZATION);
  //       const userId = localStorage.getItem("userId");

  //       HttpClient(SERVER + `/admin/adminUsers/` + userId, {
  //         method: "PUT",
  //         body: JSON.stringify({updateFcm:true, fcm: currentToken, objectId: userId }),
  //       })
  //         .then(() => {
  //           // notify('کامنت ارسال شد');
  //           // window.location.reload();

  //         })
  //         .catch((e) => {
  //           console.log('Error: fcm not sent', 'warning')
  //         });
  //     } else {
  //       // Show permission request UI
  //       console.log('No registration token available. Request permission to generate one.');
  //     }

  //   })
  //   // console.log('inajaaaaa current token for client: ', currentToken);
  //   // // axios request to update user (localstorage.getItem("userId"))


  //   .catch((err) => {
  //     console.log('An error occurred while retrieving token. ', err);
  //   });
};

// Handle incoming messages. Called when:
// - a message is received while the app has focus
// - the user clicks on an app notification created by a service worker `messaging.onBackgroundMessage` handler.
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {

      console.log("payload", payload)

      resolve(payload);
    });
  });
export const onBackgroundMessage = () => {
  new Promise((resolve) => {

    onMessage(messaging, (payload) => {

      console.log("payload", payload)

      resolve(payload);
    });

  })
}